import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ModalSizeE } from 'declarations/enums/modal';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import type { NoopT } from 'declarations/types/common';

import { getPopupContentStyle } from './ApproveAttachmentsPopup.styled';
import useApproveAttachmentsPopup from './hooks/useApproveAttachmentsPopup';

type ApproveAttachmentsPopupPropsT = {
  ticketId: string;
  fileNames: string[];
  isOpen: boolean;
  onClose: NoopT;
};

const ApproveAttachmentsPopup: FC<ApproveAttachmentsPopupPropsT> = ({
  ticketId,
  fileNames,
  isOpen,
  onClose,
}) => {
  const { isMobile } = useResponsive();
  const { isApprovingAttachments, handleApproveAttachments, handleClosePopup } =
    useApproveAttachmentsPopup();

  return (
    <Popup
      nested
      isOpen={isOpen}
      showCloseBtn
      modalTitle="Approve Attachment"
      size={ModalSizeE.APPROVE_ATTACHMENT}
      popupId={ScrollLockIdE.ApproveAttachmentsPopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%',
        }}
      >
        <Typography variant="body1" color="text.primary" align={isMobile ? 'center' : 'left'}>
          Are you sure you want to approve selected attachments?
        </Typography>
        <Box sx={{ flex: 1, minHeight: 16 }} />
        <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} sx={{ mt: 2, pt: 1 }}>
          <Button
            variant="contained"
            disabled={isApprovingAttachments}
            onClick={handleApproveAttachments({ ticketId, fileNames }, onClose)}
          >
            {isApprovingAttachments ? 'Approving...' : 'Approve'}
          </Button>
        </Box>
      </Box>
    </Popup>
  );
};

export default ApproveAttachmentsPopup;
